module.exports = __webpack_public_path__ + "media/images/flags/1x1/blm-b73e0bbaafb39b285aa74c6b0a30633e.svg";